export default "__VITE_ASSET__MyJFEFZq__"